<template>
  <div class="month">
    <div class="month__week month__week--headers">
      <div v-for="day in weekdays" :key="day" @click="onClick">
        {{ day }}
      </div>
    </div>
    <div class="month__week" v-for="(week, index) in weeks" :key="index">
      <div
        v-for="(day, index) in week"
        :key="index"
        :class="{'is-muted': !day.inMonth }"
      >
        <day v-bind="day" :active="isActive(day)" @click="onClick(day)" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { DATEFORMAT, WEEKDAYS, getCalendarDays } from '@/utilities/time';
import splitArray from '@/utilities/splitArray';
import Day from './Day.vue';

dayjs.extend(isSameOrBefore);

export default {
  name: 'Month',
  components: {
    Day,
  },
  props: {
    year: Number,
    month: Number,
    activeDays: Array,
  },
  data() {
    return {
      weekdays: WEEKDAYS,
    };
  },
  computed: {
    weeks() {
      const { year, month } = this;
      const calendarDays = getCalendarDays({ month, year });
      return splitArray(calendarDays, 7);
    },
  },
  methods: {
    isActive({ date }) {
      return this.activeDays.includes(date.format(DATEFORMAT));
    },
    onClick({ date }) {
      this.$emit('click', date);
    },
  },
};
</script>

<style lang="scss" scoped>
.month {
  &__week {
    display: flex;
    &--headers {
      font-weight: 500;
    }
    > div {
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px;
    }
  }
  .is-muted {
    opacity: 0.3;
  }
}
</style>
